<template>
  <section v-if="historyProducts.length" class="w-full md-container mb-32">
    <Swiper
      :slides-per-view="uiStore.isMobile ? 1.2 : 6"
      :space-between="24"
      :slides-offset-before="uiStore.isMobile ? 24: 0"
      :slides-offset-after="uiStore.isMobile ? 24: 0"
    >
      <SwiperSlide v-for="(product, index) in matchProducts" :key="product.ecomId">
        <div
          v-track="{
            product,
            index: index,
            listName: history.title
          }"
          class="flex flex-col"
        >
          <div class="md:text-lg text-md font-sans mb-16 h-[30px]">
            <span v-if="index === 0">{{
              $lang('product_page', 'match_with')
            }}</span>
          </div>
          <nuxt-link :to="product.route" @click="clickLink(product)">
            <nuxt-img :src="product.mainImage" />
          </nuxt-link>
        </div>
      </SwiperSlide>

      <SwiperSlide v-for="(product, index) in historyProducts" :key="product.ecomId">
        <div
          v-track="{
            product,
            index: index + matchProducts.length,
            listName: history.title
          }"
          class="flex flex-col"
        >
          <div class="md:text-lg text-md font-sans mb-16 h-[30px]">
            <span v-if="index === 0">{{
              $lang('product_page', 'latest_shown')
            }}</span>
          </div>
          <nuxt-link :to="product.route">
            <nuxt-img :src="product.mainImage" :alt="product.title"/>
          </nuxt-link>
        </div>
      </SwiperSlide>
    </Swiper>
  </section>
</template>

<script setup lang="ts">
import { type ProductHistory } from '~/constants/types/product-history';
import { useConfigStore } from '~/store/config';
import Product from '~/models/product';

import { useUiStore } from '~/store/ui';

import { pushProductClick, useProductImpressionTracking as vTrack } from '~/composables/useTracking';

const config = useConfigStore();
const { fetchProducts } = useProductService();
const uiStore = useUiStore();
const historyProducts = ref<Product[]>([]);
const matchProducts = ref<Product[]>([]);

const props = defineProps<{
  history: ProductHistory,
  hasMatchWithProducts: number,
  matchWithProducts: { ecomId: string | number }[]
}>();

const cookieId = `visitedProducts${config.market.language}`;
const visitedCookie = useCookie<string[]>(cookieId, { maxAge: 3600 * 24 * 182, path: '/', default: () => [] });

const updateCookie = () => {
  // moves self to first position
  const newCookie = visitedCookie.value.filter(f => f !== props.history.ecomId);
  newCookie.unshift(props.history.ecomId);
  visitedCookie.value = newCookie;
};

onMounted(()=> {
  loadProducts();
  updateCookie();
});

const combinedList = computed(()=> {
  return props.matchWithProducts.map(m => m.ecomId).concat(visitedCookie.value).filter((v,i,a) => a.indexOf(v) === i);
});

const loadProducts = async() => {
  const { products: loadedProducts } = await fetchProducts({
    products: combinedList.value,
  });
  if (loadedProducts) {
    historyProducts.value = visitedCookie.value.map((cId) => {
      const thisProduct =  loadedProducts.find(f => f.product+'' === cId+'');
      if (thisProduct) {
        return new Product({ ecomData: thisProduct, contentData: null });
      }
      return null;
    }).filter(f => f !== null);

    matchProducts.value = props.matchWithProducts.map((mId) => {
      const thisProduct =  loadedProducts.find(f => f.product+'' === mId.ecomId+'');
      if (thisProduct) {
        return new Product({ ecomData: thisProduct, contentData: null });
      }
      return null;
    }).filter(f => f !== null);

  } else {
    console.log('Coudnt load history');
  }
};

const clickLink = (product: Product) => {
  pushProductClick(product, 'Senaste visade');
};

</script>

<style scoped lang="postcss">
</style>
